import script from "./NfseSection.vue?vue&type=script&setup=true&lang=js"
export * from "./NfseSection.vue?vue&type=script&setup=true&lang=js"

import "./NfseSection.vue?vue&type=style&index=0&id=361238af&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-361238af"]])

export default __exports__